const COURTS_MARKETING_URL = {
	de: "https://onsand.cloud/de/plaetze",
	en: "https://onsand.cloud/en/courts",
} as const;

/** The full court-booking pitch on club-landing, localized ("Mehr erfahren" target). */
export function courtsMarketingUrl(locale: string): string {
	return locale === "en" ? COURTS_MARKETING_URL.en : COURTS_MARKETING_URL.de;
}
